import 'flag-icons/css/flag-icons.min.css';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import { validateURL } from '../../../../utils/stringHelper';
import CityAutocomplete from '../../../../components/Display/CityAutocomplete';
import ImageForm from '../../common/image/ImageForm';
import PropertyField from '../../../../components/Properties/PropertyField';

function MemberPanel({ isOpen, onClose, onCreate, member, onUpdate, loading }) {
  const [name, setName] = useState('');
  const [type, setType] = useState([]);
  const [logo, setLogo] = useState(undefined);
  const [city, setCity] = useState(undefined);
  const [email, setEmail] = useState('');
  const [externalUrl, setExternalUrl] = useState('');
  const [placeQuery, setPlaceQuery] = useState('');

  useEffect(() => {
    if (member) {
      setName(member.name);
      setType(member.type.map((t) => t.id));
      setLogo(member.logo);
      setCity(member.city);
      setEmail(member.email);
      setExternalUrl(member.external_url);
      setPlaceQuery(member.city.city);
    } else {
      setName('');
      setType([]);
      setLogo(undefined);
      setCity('');
      setEmail('');
      setExternalUrl('');
      setPlaceQuery('');
    }
  }, [member, isOpen]);

  console.log(city);

  const handleValidate = () => {
    const memberPayload = {
      name,
      type,
      logo: logo?.id,
      place_id: city?.place_id,
      email,
      external_url: externalUrl
    };
    member ? onUpdate(memberPayload) : onCreate(memberPayload);
  };

  const formIsValid = () => {
    return name && city && type?.length;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${member ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 600 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={<h3>{`${member ? 'Modifier' : 'Ajouter'} un membre`}</h3>}>
      <div className="sidebar-content-container">
        <div className="form-wrapper !pb-60">
          <FormInput key="Nom" label={"Nom de l'adhérent"} required isValid={name}>
            <InputText
              id="title"
              value={name}
              maxLength={300}
              placeholder="Veuillez saisir le nom de l'adhérent"
              onChange={(e) => setName(e.target.value)}
            />
          </FormInput>

          <FormInput key="Type" label={"Type de l'adhérent"} required isValid={type?.length}>
            <PropertyField
              type={'rab_member_type'}
              selectedPropertyList={type}
              setSelectedPropertyList={setType}
              scope={'rab'}
            />
          </FormInput>
          <FormInput label={'Lieu'} required isValid={city}>
            <CityAutocomplete
              setSelectedPlace={setCity}
              placeQuery={placeQuery}
              setPlaceQuery={setPlaceQuery}
            />
          </FormInput>
          <FormInput key="Email" label={'Email'}>
            <InputText
              id="email"
              value={email}
              maxLength={300}
              placeholder="Veuillez saisir l'email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormInput>
          <FormInput
            key="ExternalUrl"
            label={'Url externe'}
            errorMessage={
              !validateURL(externalUrl) && "L'URL doit commencer par http:// ou https://"
            }>
            <InputText
              id="externalUrl"
              value={externalUrl}
              maxLength={300}
              placeholder="Veuillez saisir l'url externe"
              onChange={(e) => setExternalUrl(e.target.value)}
              invalid={!validateURL(externalUrl)}
            />
          </FormInput>
          <ImageForm
            image={logo}
            setImage={setLogo}
            required={false}
            deleteImage={() => setLogo(undefined)}
            label={'Logo'}
          />
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default MemberPanel;
